import React from 'react';
import { Button } from 'antd';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import buttons from 'helpers/styles/components/buttons.module.sass';
import { UserSkill } from 'helpers/types/Skills';
import { UserDetails } from 'api/User/types';
import { UserRedux } from 'redux/User/types';
import { USER_TYPES } from 'helpers/constants/_common/constants';
import userRequests from 'api/PersonalInfo/requests';

import s from './styles.module.sass';


interface DownloadSkillsetJSONButtonProps {
    login: UserDetails | UserRedux;
    userId: number;
}


const DownloadSkillsetJSONButton: React.FC<DownloadSkillsetJSONButtonProps> = ({login, userId}) => {
  const isVisible = login.usertype == USER_TYPES.ADMIN;
  return <div className={s.DownloadSkillsetJSONButtonWrapper}>
    <Button type="primary" hidden={!isVisible} className={buttons.qsButtonPrimary} onClick={async () => {
        const skillset = await userRequests.downloadSkillsetJSON(userId);
        const json = JSON.stringify(skillset, null, 2);
        const blob = new Blob([json], { type: "application/json" });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `user_${userId}_skillset.json`;
        a.click();

        window.URL.revokeObjectURL(url);
     
    }}>
      <FontAwesomeIcon icon="download" />
      Download JSON
    </Button>
  </div>
};

export default DownloadSkillsetJSONButton;
